"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultBatchThrottle = exports.defaultBatchSize = void 0;
const axios_1 = __importDefault(require("axios"));
const winston_transport_1 = __importDefault(require("winston-transport"));
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
exports.defaultBatchSize = 100;
exports.defaultBatchThrottle = 1000;
class WinstonNewrelicLogsTransport extends winston_transport_1.default {
    constructor(options) {
        var _a, _b, _c;
        super(options);
        this.logs = [];
        this.axiosClient = axios_1.default.create(Object.assign(Object.assign({ timeout: 5000 }, options.axiosOptions), { baseURL: options.apiUrl, headers: Object.assign(Object.assign({}, (_a = options.axiosOptions) === null || _a === void 0 ? void 0 : _a.headers), { 'Api-Key': options.licenseKey, 'Content-Type': 'application/json' }) }));
        if (options.batchSize !== undefined ||
            options.batchThrottle !== undefined) {
            this.batchSize =
                options.batchSize === true
                    ? exports.defaultBatchSize
                    : (_b = options.batchSize) !== null && _b !== void 0 ? _b : exports.defaultBatchSize;
            this.batchThrottle =
                options.batchThrottle === true
                    ? exports.defaultBatchThrottle
                    : (_c = options.batchThrottle) !== null && _c !== void 0 ? _c : exports.defaultBatchThrottle;
            if (this.batchSize <= 0) {
                throw new Error('Expected a batchSize greater than 0');
            }
            if (this.batchThrottle <= 0) {
                throw new Error('Expected a batchThrottle greater than 0');
            }
            this.throttledBatchPost = (0, lodash_throttle_1.default)(this.batchPost.bind(this), this.batchThrottle, { leading: false, trailing: true });
        }
    }
    batchPost() {
        try {
            const logs = this.logs.slice();
            this.logs = [];
            const data = [
                {
                    logs,
                },
            ];
            this.axiosClient
                .post('/log/v1', data)
                .then(() => {
                for (const log of logs) {
                    this.emit('logged', log);
                }
            })
                .catch((err) => {
                this.emit('error', err);
            });
        }
        catch (err) {
            this.emit('error', err);
        }
    }
    log(data, callback) {
        const entry = validateData(data);
        if (!entry.timestamp) {
            entry.timestamp = Date.now();
        }
        if (this.throttledBatchPost && this.batchSize && this.batchSize > 0) {
            this.logs.push(entry);
            this.throttledBatchPost();
            if (this.logs.length >= this.batchSize) {
                this.throttledBatchPost.flush();
            }
            callback(null);
        }
        else {
            this.axiosClient
                .post('/log/v1', entry)
                .then(() => {
                this.emit('logged', entry);
                callback(null);
            })
                .catch((err) => {
                this.emit('error', err);
                callback(err);
            });
        }
    }
}
exports.default = WinstonNewrelicLogsTransport;
function validateData(data) {
    if (data === null) {
        return {};
    }
    else if (typeof data !== 'object') {
        return { metadata: data };
    }
    else {
        return (0, lodash_clonedeep_1.default)(data);
    }
}
//# sourceMappingURL=index.js.map